import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { StepperButton } from './stepper-button';
import { durationPickerVariants, durationPickerSectionVariants, durationPickerInputVariants } from './styling';
import { cn } from '../../../utils';
export function DurationPicker({ duration, onChange, className, width }) {
    const [hours, setHours] = useState(Math.floor(duration / 60));
    const [minutes, setMinutes] = useState(duration % 60);
    const handleMinutesChange = (increment) => {
        let newMinutes = increment ? minutes + 5 : minutes - 5;
        let newHours = hours;
        if (newMinutes >= 60) {
            newMinutes = newMinutes % 60;
            newHours += Math.floor((minutes + (increment ? 5 : -5)) / 60);
        }
        else if (newMinutes < 0) {
            newMinutes = 60 + newMinutes;
            newHours -= 1;
        }
        if (newHours < 0) {
            newHours = 0;
            newMinutes = 0;
        }
        setMinutes(newMinutes);
        setHours(newHours);
        onChange(newHours * 60 + newMinutes);
    };
    const handleMinutesInputChange = (e) => {
        let newMinutes = e.target.valueAsNumber;
        if (isNaN(newMinutes)) {
            newMinutes = 0;
        }
        if (hours === 24) {
            return;
        }
        if (newMinutes > 59) {
            newMinutes = 59;
        }
        setMinutes(newMinutes);
        onChange(newMinutes + hours * 60);
    };
    const handleInputChange = (e) => {
        const input = e.currentTarget;
        // Remove non-numeric characters and limit to 2 digits
        input.value = input.value.replace(/[^0-9]/g, '').slice(0, 2);
        // Prevent empty input
        if (input.value === '') {
            input.value = '0';
            return;
        }
        // Prevent multiple leading zeros
        if (input.value.startsWith('0') && input.value.length > 1) {
            input.value = input.value.slice(1);
        }
    };
    const handleHoursInputChange = (e) => {
        let newHours = e.target.valueAsNumber;
        if (isNaN(newHours)) {
            newHours = 0;
        }
        if (newHours > 24) {
            newHours = 24;
            setMinutes(0);
        }
        setHours(newHours);
        onChange(newHours * 60 + minutes);
    };
    return (_jsxs("div", { className: cn(durationPickerVariants({ width }), 
        // {
        //   'border-red-500 focus-within:outline-red-500': error,
        // },
        className), children: [_jsxs("div", { className: durationPickerSectionVariants({ width }), children: [_jsx("input", { type: "number", value: hours, onChange: handleHoursInputChange, onInput: handleInputChange, className: cn(durationPickerInputVariants({ width })) }), _jsx("span", { className: "text-gray-500 text-sm pointer-events-none", children: `hr${hours !== 1 ? 's' : ''}` })] }), _jsxs("div", { className: cn(durationPickerSectionVariants({ width }), 'relative'), children: [_jsx("div", { className: "absolute left-0 top-1/2 -translate-y-1/2 w-px h-6 bg-gray-100" }), _jsx("input", { type: "number", value: minutes, onChange: handleMinutesInputChange, onInput: handleInputChange, className: cn(durationPickerInputVariants({ width })) }), _jsx("span", { className: "text-gray-500 text-sm pointer-events-none", children: "min" })] }), _jsxs("div", { className: "border-l divide-y border-gray-100 z-10", children: [_jsx(StepperButton, { direction: "up", onClick: () => handleMinutesChange(true) }), _jsx(StepperButton, { direction: "down", onClick: () => handleMinutesChange(false) })] })] }));
}
